import { Controller } from '@hotwired/stimulus'
import { enter, leave } from 'el-transition'

export default class extends Controller {
  static targets = [
    'selectable',
    'selectableList',
    'selected',
    'selectedIdsInput',
    'selectedList',
  ]

  static values = { selectedIds: Array }

  connect() {
    this.selectedTargets.forEach((selectedTarget) => {
      this.#add(selectedTarget)
    })
  }

  addAll(event) {
    event.preventDefault()
    this.selectableTargets.forEach((selectableTarget) => {
      if (Valence.Utils.Visibility.isVisibleByClass(selectableTarget)) {
        this.#add(selectableTarget)
      }
    })
  }

  addItem(event) {
    event.preventDefault()

    const selectableTarget =
      event.target.closest('[data-multiselect-target="selectable"]')

    this.#add(selectableTarget)
  }

  removeAll(event) {
    event.preventDefault()
    this.selectedTargets.forEach((selectedTarget) => {
      if (Valence.Utils.Visibility.isVisibleByClass(selectedTarget)) {
        this.#remove(selectedTarget)
      }
    })
  }

  removeItem(event) {
    event.preventDefault()

    const selectedTarget =
      event.target.closest('[data-multiselect-target="selected"]')

    this.#remove(selectedTarget)
  }

  selectableTargetConnected(element) {
    if (this.selectedIdsValue.includes(element.dataset.multiselectInputId) &&
      element.dataset.selected !== 'true') {
      leave(element)
    }
  }

  selectedIdsValueChanged() {
    if (this.hasSelectedIdsInputTarget) {
      this.selectedIdsInputTarget.value = this.selectedIdsValue.join(',')
    }
  }

  #add(selectableTarget) {
    this.selectedIdsValue = this.
      selectedIdsValue.
      concat([selectableTarget.dataset.multiselectInputId])

    selectableTarget.
      querySelector('.js-multiselect--checkbox').
      checked = true

    leave(selectableTarget.querySelector('.js-multiselect--add'))
    enter(selectableTarget.querySelector('.js-multiselect--remove'))
    selectableTarget.dataset.multiselectTarget = 'selected'

    this.selectedListTarget.appendChild(selectableTarget)
  }

  #remove(selectedTarget) {
    this.selectedIdsValue = this.
      selectedIdsValue.
      filter((id) => id !== selectedTarget.dataset.multiselectInputId)

    selectedTarget.
      querySelector('.js-multiselect--checkbox').
      checked = false

    leave(selectedTarget.querySelector('.js-multiselect--remove'))
    enter(selectedTarget.querySelector('.js-multiselect--add'))
    selectedTarget.dataset.multiselectTarget = 'selectable'

    this.selectableListTarget.prepend(selectedTarget)
  }
}
